import React from 'react'
import { Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import {
  formatCpfCnpj,
  formatDate,
  formatDateTime
} from '../../../utils/Formatter'

const useStyles = makeStyles(theme => ({
  items: {
    padding: theme.spacing(2)
  }
}))

const FichaComponent = ({ data }) => {
  const classes = useStyles()

  const renderVeiculos = veiculos => {
    return (
      <>
        {veiculos.map((veiculo, index) => (
          <Grid item xs={12} key={index}>
            <Paper className={classes.items}>
              <Typography variant="h5" gutterBottom>
                {index === 0 ? `Cavalo` : `Carreta ${index}`}
              </Typography>
              <Grid
                container
                direction="row"
                justifyC="flex-start"
                alignItems="center"
              >
                <Grid item sm={4}>
                  <Typography variant="body1" gutterBottom>
                    <strong>Placa: </strong>
                    {veiculo.placa}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Proprietario: </strong>
                    {veiculo.proprietario}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Chassi: </strong>
                    {veiculo.chassi}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Renavam: </strong>
                    {veiculo.renavam}
                  </Typography>
                </Grid>
                <Grid item sm={4}>
                  <Typography variant="body1" gutterBottom>
                    <strong>Modelo: </strong>
                    {veiculo.modelo}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>UF: </strong>
                    {veiculo.uf}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Ano: </strong>
                    {veiculo.ano}
                  </Typography>
                </Grid>
                <Grid item sm={4}>
                  <Typography variant="body1" gutterBottom>
                    <strong>RNTRC: </strong>
                    {veiculo.rntrc}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Emissão: </strong>
                    {formatDate(veiculo.dataEmissao)}
                  </Typography>

                  <Typography variant="body1" gutterBottom>
                    <strong>Vencimento: </strong>
                    {formatDate(veiculo.dataVencimento)}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        ))}
      </>
    )
  }

  const renderEmpresa = (title, empresa) => {
    return (
      <Grid item xs={12}>
        <Paper className={classes.items}>
          <Typography variant="h5" gutterBottom>
            {title}:
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item sm={6}>
              <Typography variant="body1" gutterBottom>
                <strong>Nome Remetente: </strong>
                {empresa.nome}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>CNPJ: </strong>
                {formatCpfCnpj(empresa.cnpj)}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Inscr. Estadual: </strong>
                {empresa.IE}
              </Typography>
            </Grid>
            <Grid item sm={6}>
              <Typography variant="body1" gutterBottom>
                <strong>Cidade-UF: </strong>
                {empresa.cidadeUF}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Endereço: </strong>
                {empresa.endereco}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    )
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper className={classes.items}>
          <Typography variant="h5" gutterBottom>
            Dados Solicitacao #{data.id}
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item sm={6}>
              <Typography variant="body1" gutterBottom>
                <strong>Num. Romaneio: </strong>
                {data.numRomaneio}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Operação: </strong>
                {data.operacao.join(' / ')}
              </Typography>
            </Grid>
            <Grid item sm={6}>
              <Typography variant="body1" gutterBottom>
                <strong>Mercadoria: </strong>
                {data.mercadoria}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Peso: </strong>
                {data.peso} - {data.unidade}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Tipo: </strong>
                {data.tipo}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      {renderEmpresa('Remetente', data.remetente)}
      {renderEmpresa('Coleta', data.coleta)}
      {renderEmpresa('Destinatário', data.destinatario)}
      {renderEmpresa('Entrega', data.entrega)}
      {renderVeiculos(data.veiculos)}
      <Grid item xs={12}>
        <Paper className={classes.items}>
          <Typography variant="h5" gutterBottom>
            Motorista:
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item sm={4}>
              <Typography variant="body1" gutterBottom>
                <strong>Nome: </strong>
                {data.motorista.nome}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>CNH: </strong>
                {data.motorista.cnh}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>CPF: </strong>
                {data.motorista.cpf}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Carteira de Identidade: </strong>
                {data.motorista.carteiraIdentidade}
              </Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography variant="body1" gutterBottom>
                <strong>Expedição: </strong>
                {formatDate(data.motorista.dataExpedicao)}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>UF: </strong>
                {data.motorista.uf}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Expedidor: </strong>
                {data.motorista.expedidor}
              </Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography variant="body1" gutterBottom>
                <strong>RNTRC: </strong>
                {data.motorista.rntrc}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Emissão: </strong>
                {formatDate(data.motorista.dataEmissao)}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Vencimento: </strong>
                {formatDate(data.motorista.dataVencimento)}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.items}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item sm={4}>
              <Typography variant="body1" gutterBottom>
                <strong>Carregamento Início: </strong>
                {formatDateTime(data.carregamentoInicio)}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Carregamento Fim: </strong>
                {formatDateTime(data.carregamentoFin)}
              </Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography variant="body1" gutterBottom>
                <strong>Entrega Início: </strong>
                {formatDateTime(data.entregaInicio)}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Entrega Fim: </strong>
                {formatDateTime(data.entregaFim)}
              </Typography>
            </Grid>
            <Grid item sm={4}>
              <Typography variant="body1" gutterBottom>
                <strong>Usuário: </strong>
                {data.nomeUsuario}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}
export default FichaComponent
